import { Quill } from 'react-quill-new';

const Link = Quill.import('formats/link')

class CustomLinkSanitizer extends Link {
  static sanitize(url) {
    // Run default sanitize method from Quill.
    const sanitizedUrl = super.sanitize(url)

    // Check for relative links that need to be made into an absolute link. We want to avoid matching:
    // - Cases where it is another protocol (has a : like mailto:),
    // - Cases where it is an intentional relative link with a single /.
    // - Cases where it is an absolute link (these all have a : in them)
    // It is key to check that it starts and ends with this regex, otherwise it can incorrectly match with partials
    // e.g. if it was an intentional relative link.
    // See examples of the regex with test cases at: https://regex101.com/r/h8PZdE/1
    const match = sanitizedUrl.match(/(^[^/#][^:]*)$/);
    if(match) {
      return `https://${sanitizedUrl}`
    }
    return sanitizedUrl
  }
}

export default CustomLinkSanitizer;
